import types from './mutations-types';

const mutations = {
  [types.SET_LIST](state, payload) {
    state.list = [
      {
        _id: '1',
        title: 'Padrão',
        scale: 'colors',
        border: 'colors',
        grade: '#606060',
        button: '#7da38b',
        body: `<p>Obrigado por escolher a nossa empresa.</p>
    <p>Gostaríamos de aperfeiçoar a sua experiência com os nossos serviços através deste
      questionário que dura apenas 60 segundos.
    </p>
    <p>Agradecemos a sua colaboração.<br />`,
      },
      {
        _id: '3',
        title: '3 Cores',
        scale: 'fixedColors',
        border: 'colors',
        grade: '#606060',
        button: '#7da38b',
        body: `<p>Obrigado por escolher a nossa empresa.</p>
    <p>Gostaríamos de aperfeiçoar a sua experiência com os nossos serviços através deste
      questionário que dura apenas 60 segundos.
    </p>
    <p>Agradecemos a sua colaboração.<br />`,
      },
      {
        _id: '2',
        title: 'Custom',
        scale: 'custom',
        border: 'custom',
        grade: '#606060',
        button: '#7da38b',
        body: `<p>Obrigado por escolher a nossa empresa.</p>
    <p>Gostaríamos de aperfeiçoar a sua experiência com os nossos serviços através deste
      questionário que dura apenas 60 segundos.
    </p>
    <p>Agradecemos a sua colaboração.<br />`,
      },
    ];

    payload.forEach((el) => {
      state.list.push(el);
    });
  },
  [types.SET_TEMPLATE](state, payload) {
    state.templateSelected = {
      ...state.templateSelected,
      ...payload,
    };
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/templates/mutations.js